import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  CRUD_QUESTION_CATEGORY,
} from "@routes";

const apiConfig = [
  {
    name: "getQuestionCategory",
    method: "get",
    url: CRUD_QUESTION_CATEGORY,
    stateKey: "questionCategoryData",
  },
];

// ---------------------------------------------------------------------

const customReducers = {
  initialState: {
    questionCategoryData: [],
  },

  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "questionCategory",
  apiConfig,
  customReducers,
);

const questionCategorySlice = slice;

export default questionCategorySlice.reducer;

export const {
  getQuestionCategory,
} = thunks;

export const {rowSelect
} = actions;
